import { useSelector as useReduxSelector, TypedUseSelectorHook, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "./index";

// Re-export types from store for convenience
export type { RootState, AppDispatch };

// Typed hooks for use throughout the app
export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;
export const useAppDispatch = () => useDispatch<AppDispatch>();

// For backward compatibility with existing thunk usage
export type { AppThunk } from "@reduxjs/toolkit";
